import Axios from "./caller.service";
let getAllCarModels = async () => {
    const {data} = await Axios.get('/api/car_models')
    return data
}

export const carModelService = {
    getAllCarModels
}